// extracted by mini-css-extract-plugin
export default {"button":"qUNj6A","text":"ZyQvAR","newButtonUi":"WWUEBm","searchFadeIn":"qDtw4T"};